/**
 * 共通処理
 *
 * @param {boolean} change_data 編集中フラグ
 * @author hayakawa 2023.10.18
 */

// 処理
$(function() {
    // tooltip
    $('[data-toggle="tooltip"]').tooltip();

    // 機能メニューオーバーライド
    $('.btn-menu-toggle').on('click', function() {
        $(this).parent('section').hide('fast');
        $(this).parent('section').next().show('fast');
        $(this).parent('section').prev().show('fast');
    });

    // セレクトボックスのプレースホルダクラスの付け替え
    $(document).on('focus', 'select.placeholder', function() {
        $(this).removeClass('placeholder');
    });
    $(document).on('blur', 'select.placeholder', function() {
        if (!$(this).find('option:selected').val()) {
            $(this).addClass('placeholder');
        }
    });
    $('select.placeholder').each(function() {
        if ($(this).find('option:selected').val()) {
            $(this).removeClass('placeholder');
        }
    });

    // 無効化済みのチェックボックスクリック
    $(document).on('click', '.disabled-view', function() {
        $(this).prop('checked', !$(this).prop('checked'))
    });

    // 入力フォーム全角数字(全角ハイフン)→半角数字(半角ハイフン)
    $(document).on('blur', '.half-size-number', function() {
        const str = $(this).val(),
            str_replaced = str.replace(/[０-９]|[－]/g, function(e) {
                return String.fromCharCode(e.charCodeAt(0) - 0xFEE0);
            });

        $(this).val(str_replaced);
    });

    // フォーカス時カンマを外す
    $(document).on('focus', '.add-comma', function() {
        const str = $(this).val(),
            remove_comma = str.replace(/,/g, '');

        $(this).val(remove_comma);
    });

    // 全角数字→半角数字&フォーカスアウト時カンマを付与
    $(document).on('blur', '.add-comma', function() {
        const str = $(this).val(),
            str_replaced_harf = str.replace(/[０-９]/g, function(e) {
                return String.fromCharCode(e.charCodeAt(0) - 0xFEE0);
            }),
            add_comma = str_replaced_harf.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

        $(this).val(add_comma);
    });

    // パネルボタンON・OFF
    // data-group => グループ名(同一グループ内で1つだけactive可)
    // data-param => パラメータ名
    // data-val   => 値(1: active, 0: none)
    // data-null  => nullを許可するか否か(1: 可, 0: 否)
    $('.panel-button').on('click', function() {
        const this_group = ($(this).data('group') === undefined) ? 'group' : $(this).data('group'),
            this_param = ($(this).data('param') === undefined) ? 'param' : $(this).data('param'),
            this_val = ($(this).data('val') === undefined) ? 0 : $(this).data('val'),
            this_flag = ($(this).data('flag') === undefined) ? 0 : $(this).data('flag'),
            this_null = ($(this).data('null') === undefined) ? 0 : $(this).data('null'),
            others = $('[data-group="'+this_group+'"]').not(this);

        // 対象のval、class付け替え
        (this_val === 0) ? $(this).data('val', 1).addClass('active').children('input').prop('disabled', false) : $(this).data('val', 0).removeClass('active').children('input').prop('disabled', true);
        // 対象以外のval、class付け替え
        if (this_null !== 1) {
            (this_val === 0) ? others.data('val', 0).removeClass('active').children('input').prop('disabled', true) : $(this).data('val', 1).addClass('active').children('input').prop('disabled', false);
        }
        // メッセージグループ設定専用処理
        if (this_group.includes('member-')) {
            $('.table-message-group tr').removeClass('bg-lightgray');
            $('[data-param="In"]').not('.active').parents('tr').addClass('bg-lightgray');
        }
        change_data = true;
        $('#header-menu-logout').removeAttr('href onclick');
    });

    // パネルボタンON・OFF
    $('.panel-button-dark').on('click', function() {
        const has_active = $(this).hasClass('active'),
            param = $(this).attr('data-param');

        if (has_active) {
            $(`[name=${param}]`).val('');
            $(this).removeClass('active');
        } else {
            $(`[name=${param}]`).val('1');
            $(this).addClass('active');
        }
    });

    // 印刷
    $('#btn-print').on('click', function() {
        window.print();
    });
});
